<template>
  <div class="">
    <el-form :inline="true" class="demo-form-inline clearfix">
      <el-form-item label="用户编码：" class="tinp">
        <el-input v-model="user_code" placeholder="请输入用户编码" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
      </el-form-item> 
      <el-form-item label="用户名称：" class="tinp">
        <el-input v-model="user_name" placeholder="请输入用户名称" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
      </el-form-item>
      <el-form-item label="门店：" class="tinp" style="">
        <el-select @change="selectchange" filterable value-key="storecode" v-model="store.storename" clearable placeholder="请选择门店" style="width:100%;" auto-complete="off">
          <el-option v-for="item in storeList" :key="item.storecode" :label="item.storename" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" class="" size="small" icon="el-icon-search" @click="getlist">搜索</el-button>
      <el-button type="primary" class="fr" size="small" icon="el-icon-plus" @click="addUser">新增</el-button>
    </el-form>
    <div class="tablebox kucun">
      <!-- width:100% -->
      <table style="min-width: 1200px;">
        <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
          <th style="" v-for="head in tableHeads">{{ head.label }}</th>
          <th>修改</th>
          <th>删除</th>
          <!-- <th>锁定</th> -->
        </tr>
        <tr v-for="(item,index) in tableList" :key="item.period">
          <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px">
            <span>{{item[head.key]}}</span>
          </td>
          <td style="border: 1px solid #56B8AA; height: 38px;">
            <el-button type="warning" class="" size="mini" @click="modify(index,item.user_code)">修改</el-button>
          </td>
          <td style="border: 1px solid #56B8AA; height: 38px;">
            <el-button type="danger" class="" size="mini" @click="dellist(index,item.user_code,item.pk_userlogin)">删除</el-button>
          </td>
         <!--  <td style="border: 1px solid #56B8AA; height: 38px;">
            <el-button type="danger" class="" size="mini" @click="lockedUser(index,item.user_code)" v-if="item.islocked =='N'">锁定</el-button>
            <el-button type="danger" class="" size="mini" disabled="disabled" v-else>锁定</el-button>
          </td> -->
        </tr>
        <tr v-if="tableList.length==0">
          <td colspan="11" style="border:0;background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
        </tr>
      </table>
    </div>
    <!-- fenye start -->
    <div class="block" style="text-align: center;margin:20px auto ">
      <span><el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count"></el-pagination></span>
    </div>
    <!-- fenye end -->
    <!-- Modal  start-->
    <div class="model updateuser" v-show="userShow">
      <div class="content clearfix">
        <div class="title">
          <span class="fl">修改用户信息</span>
          <span class="fr" @click="closemodel"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="" style="padding: 0 20px">
          <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="demo-ruleForm my user">
             <el-form-item label="所属法人公司：" prop="corpname" class="passlabel" style="">
              <el-select @change="selectchange1" filterable value-key="corpcode" v-model="userForm.corpname" clearable placeholder="请选择门店"  style=" width:308px;"  auto-complete="off">
                <el-option v-for="item in corpList" :key="item.corpcode" :label="item.corpname" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属门店：" prop="storename" class="passlabel" style="">
              <el-select @change="selectchange2" filterable value-key="storecode" v-model="userForm.storename" clearable placeholder="请选择门店"  style="width:308px;"  auto-complete="off">
                <el-option v-for="item in storeList2" :key="item.storecode" :label="item.storename" :value="item" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户名称：" prop="user_name" class="passlabel">
              <el-input type="text" v-model="userForm.user_name" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
            </el-form-item>
           <!--  <el-form-item label="原始密码：" prop="oldpass" class="passlabel">
              <el-input type="password" v-model="userForm.oldpass" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="新密码：" prop="pass" class="passlabel">
              <el-input type="password" v-model="userForm.pass" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="checkPass" class="passlabel">
              <el-input type="password" v-model="userForm.checkPass" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="角色选择：" class="passlabel">
              <el-select v-model="userForm.role_name" value-key="role_code" placeholder="请选择" style="width:308px;" auto-complete="off" @change="inpclick">
                <el-option v-for="item in User_Roles" :key="item.role_code" :label="item.role_name" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        <el-button size="small" type="primary" @click="submituserForm('userForm')" class="fr">确认修改</el-button>
        <el-button size="small" type="warning" class="fl" style="margin: 0px" @click="closemodel">取消修改</el-button>
        </div>
      </div>
    </div>
    <!-- Modal  end-->
    <!-- model end -->
    <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
</template>
<script>
// import MessageModel from '../../components/MessageModel'
import { setCookie, getCookie, delCookie } from '../../../static/js/cookie.js'
export default {
  name: '',
  data() {
    // var validateOldPass = (rule, value, callback) => {
    //   if(value != ''&&value.length < 6) {
    //     callback(new Error('密码不能小于6位'));
    //   } else {
    //     callback();
    //   }
    // };
    var validatePass = (rule, value, callback) => {
      if (value != ''&&value.length < 6) {
        callback(new Error('密码不能小于6位'));
      } else {
        if (this.userForm.checkPass !== '') {
          this.$refs.userForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.userForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      width: 0, //动态宽度
      userForm: {
        user_code: '',
        user_name: '',
        corpcode: '',
        corpname: '',
        storecode: '',
        storename: '',
        storehouse_code: '',
        storehouse_name: '',
        oldpass: '',
        pass: '',
        checkPass: '',
        role_code: '',
        role_name: '',
        pk_userlogin:'',
        role: {
          role_code: '',
          role_name: ''
        }
      },
      fullscreenLoading:false,
      role: {},
      User_Roles: [],
      rules: {
        // oldpass: [
        //   { validator: validateOldPass, trigger: 'blur' }
        // ],
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      delusercode:'',
      lockedUsercode:'',
      storeList:[],
      store: {
        storecode: '', //门店编码
        storename: '' //门店名称
      },
      user_code: '',
      user_name: '',
      userShow: false,
      page: 1,
      pageSize: 10,
      count: 0,
      tableHeads: [ 
        //  {
        //   label: '法人公司编码',
        //   key: 'corpcode'
        // },
        {
          label: '法人公司名称',
          key: 'corpname'
        },
        // {
        //   label: '所属门店编码',
        //   key: 'storecode'
        // },
        {
          label: '所属门店名称',
          key: 'storename'
        },
        // {
        //   label: '门店仓库编码',
        //   key: 'storehouse_code'
        // }, 
        {
          label: '门店仓库名称',
          key: 'storehouse_name'
        }, 
        {
          label: '用户编码',
          key: 'user_code'
        },
        {
          label: '用户名称',
          key: 'user_name'
        }, 
        {
          label: '角色编号',
          key: 'role_code'
        },
        {
          label: '角色名称',
          key: 'role_name'
        }, 
        // {
        //   label: '是否锁定',
        //   key: 'islocked'
        // }
      ],
      pk_userlogin:'',
      corpList:[],
      storeList2:[],
      tableList: []
    }
  },
  mounted() {
    this.utilpath = this.axios.defaults.baseURL;
    this.getstore();
    this.getCorpcode();
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pageSize");
    // sessionStorage.removeItem("usersList");
    sessionStorage.removeItem("user_code");
   // console.log("清除session");
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
            // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='deluser'){
                this.fullscreenLoading = false;
                var reqparam = { 
                  pk_userlogin:this.pk_userlogin, 
                  userCode: this.user_code, //用户编码 
                  userName: this.user_name, //用户名称
                  storecode: this.store.storecode==null?'':this.store.storecode, 
                  pageNum:this.page,
                  pageSize:this.pageSize,
                } 
                this.$http.post(this.utilpath +'/deleteUser', reqparam,{ emulateJSON: true,_timeout:600 }).then((res) => {
                  if (res.data.status == '0') {
                    this.fullscreenLoading = false; 
                    this.tableList = res.data.resultList;
                    this.count = res.data.countNum;
                    this.$message({
                      showClose: true,
                      message: '删除成功！',
                      type: 'succcess'
                    });
                  } else if(res.data.status == '9'){
                        this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else {
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.msgShow = true;
                    this.methodName = 'message';
                    this.msg = res.data.message;
                    this.butflag =false;
                    this.butmsg='知道了';
                  }
                }, (err) => {
                  this.fullscreenLoading = false;
                  this.msgShow =false;
                  this.modelFlag = true;
                  this.methodName = 'message';
                  this.msg = '连接删除用户接口失败';
                  this.butflag =false;
                  this.butmsg='知道了';
                  //console.log(err);
                })
            }else if(this.methodName =='updateuser'){
               this.fullscreenLoading = false;
               this.submit();
            }
      }else{
        this.fullscreenLoading=false;
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) { 
      this.modelFlag = false; 
       if (flag) {
        //console.log("---进来了！！！----" + this.methodName);
        if (this.methodName == 'message') {

        } 
      }
    }, 
    selectchange1(value) {
      this.userForm.corpcode = value.corpcode;
      this.userForm.corpname = value.corpname;   
      this.getstore2();
    },
    selectchange2(value) {
        if(this.userForm.corpcode!=''||this.userForm.corpcode!=null){
           this.userForm.storecode = value.storecode;
           this.userForm.storename = value.storename;    
           if(value!=null||value!=''){
           this.selectreporstory(value.storecode);
           } 
        }else{
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '请先选择法人公司';
            this.butflag =false;
            this.butmsg='知道了';
        }
    }, 
     getstore() {
      //获取数据接口

      // this.$http.get('api/store').then((res) => {
      this.$http.post(this.utilpath + '/selectStore', { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          var stores = res.data.resultList;
          this.storeList = [];
          for (var i = stores.length - 1; i > -1; i--) {
            this.storeList.push({ storename: stores[i].storename, storecode: stores[i].storecode });
          }
         // console.log("打印货位" + JSON.stringify(this.storeList));
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false;
          this.$message({
            showClose:true,
            message:'暂无数据！',
            type:'info'
          });
          this.storeList = [];
         // console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
          this.fullscreenLoading = false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert(res.data.message, '失败信息', {
          //   confirmButtonText: '确定'
          // });

        }

      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了';
        // this.$alert('连接获取门店信息接口失败', '失败信息', {
        //   confirmButtonText: '确定'
        // });
        //console.log(err);
      });
    },
    getCorpcode(){
      //获取数据接口 
      this.$http.post(this.utilpath + '/selectCorpfrinfo', { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          var corp = res.data.resultList;
          this.corpList = [];
          for (var i = corp.length - 1; i > -1; i--) {
            this.corpList.push({ corpcode: corp[i].storecode, corpname: corp[i].storename });
          }
          //console.log("打印公司法人" + JSON.stringify(this.corpList));
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false;
          this.corpList = [];
          //console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
          this.fullscreenLoading = false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }

      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
        console.log(err);
      });
    },
    getstore2() {
      //参数
      var param={
        corpcode:this.userForm.corpcode,
      };
      //获取数据接口 
      this.$http.post(this.utilpath+'/selectCorpfrandmdinfo',param, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          var stores = res.data.resultList;
          this.storeList2 = [];
          for (var i = stores.length - 1; i > -1; i--) {
            this.storeList2.push({ storename: stores[i].storename, storecode: stores[i].storecode });
          }
          //console.log("打印货位" + JSON.stringify(this.storeList2));
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false;
          this.storeList2 = [];
          //console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
          // this.$alert(res.data.message, '失败信息', {
          //   confirmButtonText: '确定'
          // }); 
        }

      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了';
        // this.$alert('连接获取门店信息接口失败', '失败信息', {
        //   confirmButtonText: '确定'
        // });
        //console.log(err);
      });
    },
    getroles() {
      this.User_Roles = [];
      //获取数据接口
      this.$http.post(this.utilpath + '/selectRole', { emulateJSON: true,_timeout:600 }).then((res) => {
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          var roles = res.data.resultList;
          for (var i = 0; i < roles.length; i++) {
            this.User_Roles.push({ role_name: roles[i].role_name, role_code: roles[i].role_code });
          }
          //console.log("打印角色" + JSON.stringify(this.User_Roles));
        } else if(res.data.status == '9'){
          this.fullscreenLoading = false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.User_Roles = [];
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了';
        console.log(err);
      });
    },
    inpclick(value) {
      //console.log("打印value"+value.role_code);
      if (value != '') {
        this.userForm.role_code = value.role_code;
        this.userForm.role_name = value.role_name;
      }
      // console.log("打印value" + JSON.stringify(this.userForm.role_code)); 
    },
    closemodel() {
      this.userShow = false;
    },
    selectreporstory(storecode){
      var param={
        storecode:storecode,
      }
      //获取数据接口
      this.$http.post(this.utilpath + '/selectStoreshopmonthinfo', param,{ emulateJSON: true,_timeout:600 }).then((res) => {
         //console.log("打印返回值："+JSON.stringify(res.data));
        if (res.data.status == '0') {  
          this.fullscreenLoading = false;
              this.userForm.storehouse_code = res.data.resultList[0].repertorycode;
              this.userForm.storehouse_name = res.data.resultList[0].repertoryname; 
        }else if(res.data.status == '-1'){
          this.fullscreenLoading = false;
            //console.log("暂无数据");
        } else if(res.data.status == '9'){
          this.fullscreenLoading = false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.User_Roles = [];
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了';
        console.log(err);
      });
    },
    modify(index, user_code) {

      sessionStorage.removeItem("role");
      this.userForm.oldpass = '';
      this.userForm.pass = '';
      this.userForm.checkPass = '';
      this.userForm.corpcode = this.tableList[index].corpcode;
      this.userForm.corpname = this.tableList[index].corpname;
      this.userForm.user_code = this.tableList[index].user_code;
      this.userForm.user_name = this.tableList[index].user_name;
      this.userForm.role_name = this.tableList[index].role_name;
      this.userForm.role_code = this.tableList[index].role_code;
      this.userForm.storecode = this.tableList[index].storecode; 
      this.userForm.storename = this.tableList[index].storename;
      this.userForm.storehouse_code = this.tableList[index].storehouse_code;
      this.userForm.storehouse_name = this.tableList[index].storehouse_name;
      this.userForm.pk_userlogin = this.tableList[index].pk_userlogin; 
      sessionStorage.setItem("role", JSON.stringify(this.userForm));
      this.userShow = true;
      // this.getroles();
      this.userForm.user_code = user_code;
      //console.log("打印门店1："+this.tableList[index].storecode);
      this.getstore2();
      this.selectreporstory(this.userForm.storecode);
      if(this.tableList[index].storecode!=''||this.tableList[index].storecode!=null||this.tableList[index].storecode!=undefined){

          this.selectreporstory(this.tableList[index].storecode);
      }
    },
    dellist(index, user_code,pkUserlogin) {
      
      this.methodName = 'deluser';
      this.modelFlag = true;
      this.msgShow =false;
      this.butflag = true;
      this.butmsg='确认';
      this.msg = '此操作将删除该用户，是否继续？'
      this.delusercode = user_code;
      this.pk_userlogin=pkUserlogin
      // this.$confirm('此操作将永久删除该用户，是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
        
      // }).catch(() => {
      //   this.$message({
      //     showClose: true,
      //     type: 'info',
      //     message: '已取消删除'
      //   });
      // });
    },
    lockedUser(index, user_code) {
      this.methodName = 'lockedUser';
      this.modelFlag = true;
      this.msgShow =false;
      this.msg = '此操作锁住该用户，是否继续？'
      this.lockedUsercode = user_code;
      // this.$confirm('此操作将永久删除该用户，是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
        
      // }).catch(() => {
      //   this.$message({
      //     showClose: true,
      //     type: 'info',
      //     message: '已取消删除'
      //   });
      // });
    },
    addUser() {
      this.$router.push({ path: '/ui/system/authority/AddUser' }); //跳转页面
    },
    init() {
      //console.log("打印后端的session：");
      this.width = document.documentElement.clientWidth - 200;
      // var list = JSON.parse(sessionStorage.getItem("usersList"));
      var inp1 = sessionStorage.getItem("user_code");
      if (inp1 != null) {
        this.user_code = inp1;
        this.fullscreenLoading = false;
      }
      // if (list == null) {
        // console.log("List为空");
        this.getlist();
      // } else {
      //   this.page = parseFloat(sessionStorage.getItem("page"));
      //   this.pageSize = parseFloat(sessionStorage.getItem("pageSize"));
      //   this.tableList = list;
      //   console.log("2");
      // }
      this.count = this.tableList.length;
      // console.log("刷新数据"+JSON.stringify(list));
      this.getroles();
    },
    submituserForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          // this.$confirm('确定修改当前用户的信息？', '确认信息', {
          //     distinguishCancelAndClose: true,
          //     confirmButtonText: '修改',
          //     cancelButtonText: '放弃修改'
          //   })
          //   .then(() => {
            //  console.log("打印要提交的用户参数："+JSON.stringify( this.userForm));
              this.methodName = 'updateuser';
              this.modelFlag = true;
              this.msgShow =false;
              this.butflag = true;
              this.butmsg='确认';
              this.msg = '此操作将对用户信息进行修改，是否继续？'
             
            // }).catch(() => {
            //   this.userForm.oldpass = '';
            //   this.userForm.pass = '';
            //   this.userForm.checkPass = '';
            //   this.userForm.role = JSON.parse(sessionStorage.getItem("role"));
            //   this.$message({
            //     showClose: true,
            //     type: 'info',
            //     message: '已放弃修改'
            //   });

            // });
        } else {

          console.log('error submit!!');
          return false;
        }
      });
    },
    submit() { 
      let reqParams = {
        pk_userlogin:this.userForm.pk_userlogin,
        userCode: this.userForm.user_code, //用户编码  
        watchUserCode: this.user_code, //查询用户编码 
        updateuserName:this.user_name,//查询门店编码
        updatestorecode:this.store.storecode,//查询门店名称
        updatestorename:this.store.storecode,
        userName: this.userForm.storename==null?'':this.userForm.storename, //用户名称
        storecode: this.userForm.storecode==null?'':this.userForm.storecode,
        storename: this.userForm.storename==null?'':this.userForm.storename,
        oldpassWord: this.userForm.oldpass,
        password: this.userForm.pass,
        roleCode: this.userForm.role_code,
        roleName: this.userForm.role_name,
        corpcode: this.userForm.corpcode,
        corpname: this.userForm.corpname,
        storehouse_code: this.userForm.storehouse_code,
        storehouse_name: this.userForm.storehouse_name,
        pageNum:this.page,
        pageSize:this.pageSize,
        role:null
      }
      //console.log("打印修改参数："+JSON.stringify(reqParams));
      this.$http.post(this.utilpath + '/updateUser',reqParams, { emulateJSON: true,_timeout:600 }).then((res) => {
          var status = res.data.status;
          if (status == '0') {
            this.fullscreenLoading = false;
            this.userShow = false;
            this.$message({
              showClose: true,
              message: '修改成功！',
              type: 'success'
            });
            this.userForm.oldpass = '';
            this.userForm.pass = '';
            this.userForm.checkPass = '';
            this.tableList = res.data.resultList; 
            this.count = res.data.countNum;
          } else if(status == '9'){
            this.fullscreenLoading = false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else{
            this.userShow = false;
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了';
            // this.$message({
            //   showClose: true,
            //   message: '原始密码有误，请重新输入！',
            //   type: 'error'
            // });
            this.userForm.oldpass = '';
            this.userForm.pass = '';
            this.userForm.checkPass = '';
          }
        }, (err) => {
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '连接修改用户接口失败'+err;
            this.butflag =false;
            this.butmsg='知道了';
        });
    },
    selectchange(value) { 
        this.page = 1;
        this.store.storecode = value.storecode;
        this.store.storename = value.storename;  
        this.fullscreenLoading = false;
        this.getlist();
    },
    getlist() { //获取数据
      //搜索参数
      var reqparam = {
        watchUserCode: this.user_code, //用户编码 
        userName: this.user_name, //用户名称
        storecode: this.store.storecode==null?'':this.store.storecode,
        pageNum: this.page,
        pageSize: this.pageSize,
      }; 
     // console.log("打印参数："+JSON.stringify(reqparam));
      this.$http.post(this.utilpath +'/selectAllUser', reqparam,{emulateJSON: true,_timeout:600}).then((res) => {
            if(res.data.status=='0'){
              this.fullscreenLoading = false;
              this.tableList = res.data.resultList;
              // sessionStorage.removeItem("usersList");
              // sessionStorage.setItem("usersList", JSON.stringify(this.tableList));
              // console.log("查询数据"+JSON.stringify(this.tableList));
              // console.log("session数据"+sessionStorage.getItem("kucunlist"));
              this.count = res.data.countNum;
            //  console.log("打印数据长度：" + this.count);
            //  console.log("打印数据：" + JSON.stringify(this.tableList));
            }else if(res.data.status=='-1'){
              this.fullscreenLoading = false;
              this.tableList =[];
              this.count = 0;
              this.$message({
                showClose:true,
                message:'暂无数据',
                type:'info'
              });
            } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
            } else{
                this.fullscreenLoading = false;
                this.msgShow = true;
                this.modelFlag = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了'; 
            } 
        }, (err) => {
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '连接获取用户列表信息接口失败';
            this.butflag =false;
            this.butmsg='知道了'; 
        }); 
      sessionStorage.setItem("user_code", this.user_code);
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pageSize", this.pageSize);
    },
    handleSizeChange(val) {
     // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.page=1; 
      this.getlist();
     // console.log(this.pageSize);
    },
    handleCurrentChange(val) {
      this.fullscreenLoading =false;
     // console.log(`当前页: ${val}`);
      this.page = val;
     // console.log(this.page);

      this.getlist();
    },
    onParamChange(attr, val) { //搜索变更事件
      this.page = 1;
      this.getlist();
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/authority.vue